import React, { useState, useEffect } from 'react';
import '../styles/Clients.css';

const Clients = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const clients = [
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C1.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C2.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C3.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C4.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C5.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C6.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C7.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C8.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C9.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C10.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C11.jpg' },
    { image: 'https://metroblue.com.ng/assets/website/slider/clients/C12.jpg' },
    { 
      image: 'https://metroblue.com.ng/assets/website/slider/mtn.jpg',
      name: 'MTN',
      description: 'MTN is a South African based Telecom Giant. We partner with MTN to provide products and services to clients through our digital solution platform.'
    },
    { 
      image: 'https://metroblue.com.ng/assets/website/slider/multichoice.jpg',
      name: 'Multichoice',
      description: 'Multichoice is a South African based Entertainment Giant. We partner with Multichoice to provide subscription services to clients through our digital solution platform.'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % clients.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, [clients.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="clients" id="clients">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 text-center">
            <h2 className="text-white">Our Clients and Partners</h2>
            <div className="sub-heading">
              <p className="text-white">
                See some of our clients and partners across the globe.
              </p>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="col-md-12">
            <div className="carousel-clients">
              <div className="carousel-inner inner">
                {clients.map((client, index) => (
                  <div 
                    key={index}
                    className={`carousel-item text-center text-white ${index === currentSlide ? 'active' : ''}`}
                  >
                    <img className="center-block" src={client.image} alt={`Client ${index + 1}`} />
                    {client.name && (
                      <>
                        <h4>{client.name}</h4>
                        <h6>{client.description}</h6>
                      </>
                    )}
                  </div>
                ))}
              </div>
              
              <div className="carousel-indicators">
                {clients.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>\
    </div>
  );
};

export default Clients;